import React, { useState } from 'react';
export function SalesFooter() {
  const currentYear = new Date().getFullYear();
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <footer className="bg-brand-dark border-t border-white/10 py-8 text-center" data-id="element-122">
      <div className="container mx-auto px-6" data-id="element-123">
        <p className="text-brand-cream/60 text-sm" data-id="element-124">
          &copy; {currentYear} Borrón y Cuenta Nueva. Todos los derechos
          reservados.
        </p>

        {/* Links */}
        <div className="flex items-center justify-center gap-4 mt-6" data-id="element-125">
          <button onClick={() => setShowPrivacy(!showPrivacy)} className="text-brand-cream/50 hover:text-brand-gold text-xs underline underline-offset-2 transition-colors" data-id="element-126">
            Política de Privacidad
          </button>
          <span className="text-brand-cream/20" data-id="element-127">|</span>
          <button onClick={() => setShowTerms(!showTerms)} className="text-brand-cream/50 hover:text-brand-gold text-xs underline underline-offset-2 transition-colors" data-id="element-128">
            Términos y Condiciones
          </button>
        </div>

        <p className="text-brand-cream/30 text-[10px] mt-3 max-w-xl mx-auto leading-relaxed" data-id="element-129">
          Tu privacidad es importante para nosotros. Consulta nuestra Política
          de Privacidad para conocer cómo protegemos tus datos, y nuestros
          Términos y Condiciones para entender las reglas de uso de este
          producto digital.
        </p>

        {/* Política de Privacidad */}
        {showPrivacy && <div className="mt-6 max-w-3xl mx-auto bg-white/5 border border-white/10 rounded-xl p-6 text-left text-brand-cream/70 text-xs leading-relaxed space-y-3" data-id="element-130">
            <h3 className="text-brand-gold font-bold text-sm mb-3 text-center" data-id="element-131">
              Política de Privacidad
            </h3>
            <p data-id="element-132">
              En Borrón y Cuenta Nueva, respetamos tu privacidad y nos
              comprometemos a proteger tu información personal. Esta política
              describe cómo recopilamos, usamos y protegemos tus datos.
            </p>
            <p data-id="element-133">
              <strong className="text-brand-cream/90" data-id="element-134">
                Información que recopilamos:
              </strong>{' '}
              Recopilamos únicamente la información necesaria para procesar tu
              compra, como tu nombre, correo electrónico y datos de pago. No
              almacenamos información de tarjetas de crédito en nuestros
              servidores.
            </p>
            <p data-id="element-135">
              <strong className="text-brand-cream/90" data-id="element-136">
                Protección de datos:
              </strong>{' '}
              Utilizamos medidas de seguridad estándar de la industria,
              incluyendo cifrado SSL, para proteger tu información durante la
              transmisión y el almacenamiento.
            </p>
            <p data-id="element-137">
              <strong className="text-brand-cream/90" data-id="element-138">Cookies:</strong> Este
              sitio puede utilizar cookies para mejorar tu experiencia de
              navegación y analizar el tráfico del sitio. Puedes desactivar las
              cookies en la configuración de tu navegador.
            </p>
            <p data-id="element-139">
              Esta política puede actualizarse periódicamente. Te recomendamos
              revisarla con regularidad.
            </p>
          </div>}

        {/* Términos y Condiciones */}
        {showTerms && <div className="mt-6 max-w-3xl mx-auto bg-white/5 border border-white/10 rounded-xl p-6 text-left text-brand-cream/70 text-xs leading-relaxed space-y-3" data-id="element-140">
            <h3 className="text-brand-gold font-bold text-sm mb-3 text-center" data-id="element-141">
              Términos y Condiciones
            </h3>
            <p data-id="element-142">
              Al adquirir el sistema "Borrón y Cuenta Nueva", aceptas los
              siguientes términos y condiciones. Por favor, léelos
              cuidadosamente antes de realizar tu compra.
            </p>
            <p data-id="element-143">
              <strong className="text-brand-cream/90" data-id="element-144">Producto digital:</strong>{' '}
              Este es un producto digital de descarga inmediata. Una vez
              completado el pago, recibirás acceso instantáneo al material.
              Debido a la naturaleza digital del producto, no se aceptan
              devoluciones ni reembolsos una vez entregado el acceso.
            </p>
            <p data-id="element-145">
              <strong className="text-brand-cream/90" data-id="element-146">Uso personal:</strong> El
              contenido adquirido es para uso personal y exclusivo del
              comprador. Queda prohibida la reproducción, distribución, reventa
              o compartición del material sin autorización expresa por escrito.
            </p>
            <p data-id="element-147">
              Al realizar tu compra, confirmas que has leído, entendido y
              aceptado estos términos y condiciones en su totalidad.
            </p>
          </div>}
      </div>
    </footer>;
}